import React, { useEffect } from 'react';
import { useConsent } from '../store/consent';

declare global {
  interface Window {
    adsbygoogle?: any[];
  }
}

const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT_ID;

// Diskret annonseplass. adsbygoogle.js lastes globalt fra public/index.html (nødvendig for
// Googles sitedokumentasjon-verifisering); her pusher vi kun selve annonseenheten.
// Vises kun når REACT_APP_ADSENSE_CLIENT_ID og slot er satt i .env.local — ellers rendres
// ingenting, så lokal utvikling og bygg uten AdSense-godkjenning ikke påvirkes.
export const AdBanner: React.FC<{ slot: string }> = ({ slot }) => {
  const adConsent = useConsent(s => s.adConsent);
  const hasConsent = adConsent === 'granted';

  useEffect(() => {
    if (!ADSENSE_CLIENT || !slot || !hasConsent) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // adsbygoogle.js kan ha rukket å ikke laste ferdig enda, trygt å ignorere
    }
  }, [slot, hasConsent]);

  if (!ADSENSE_CLIENT || !slot || !hasConsent) return null;

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', margin: '12px 0' }}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};
